import styled from 'styled-components';

import { theme } from '@notino/react-styleguide-v20';

import { CheckoutPrice } from '@sharedComponents/Prices';
import { IBasicTestProps } from '@styles/model';
import { CypressTestNamespace } from '@utils/test';

export const StyledFreeDeliveryWrapper = styled.div.attrs<IBasicTestProps>(() => ({
  className: CypressTestNamespace.EFreeDeliveryProgressBar.FREE_DELIVERY_WRAPPER,
}))`
  margin: 0 auto;
  text-align: center;
`;

export const StyledIconWrapper = styled.div`
  width: 1.25rem;
  height: 1.5rem;
`;

export const StyledText = styled.div<{ isCompleted: boolean }>`
  display: inline-flex;
  font-size: 1rem;
  margin-left: 0.5rem;
  font-weight: ${({ isCompleted }) => (isCompleted ? 'bold' : 'normal')};
  color: ${({ isCompleted }) => (isCompleted ? theme.color.text.positive : theme.color.text.primary)};
`;

export const StyledTextRow = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;

export const StyledCheckoutPrice = styled(CheckoutPrice)`
  align-items: center;
  :last-child:after {
    content: '\\00a0';
  }
`;
